export const MAX_FILE_BYTES = 5 * 1024 * 1024;
export const RESUME_EXTENSIONS = ['.pdf', '.doc', '.docx'];
export const ATTACHMENT_EXTENSIONS = ['.pdf', '.doc', '.docx', '.png', '.jpg', '.jpeg'];

export const validateFile = (file, allowedExtensions) => {
  if (!file) {
    return { valid: false, error: 'No file selected.' };
  }

  const dotIndex = file.name.lastIndexOf('.');
  const extension = dotIndex > 0 ? file.name.slice(dotIndex).toLowerCase() : '';

  if (!allowedExtensions.includes(extension)) {
    return {
      valid: false,
      error: `File type not allowed. Accepted: ${allowedExtensions.join(', ')}`,
    };
  }

  if (file.size > MAX_FILE_BYTES) {
    return { valid: false, error: 'File must be under 5MB.' };
  }

  return { valid: true, error: '' };
};
